const API_VERSION = '2021-10'; // in future, could possibly use .env file for this value
export const GRAPHQL_API_ENDPOINT = `${window.theme.storeURL}/api/${API_VERSION}/graphql.json`;

export const CUSTOMER_TAGS_ENDPOINT = `${process.env.SAMPLE_CUSTOMER_TAGS_ENDPOINT}`;
export const API_TOKEN = `${process.env.SAMPLE_SUBMISSION_HEADER_TOKEN}`;